import { FirebaseActionTypes, FirebaseActions, FirebaseTypes } from '@web_opxp/features';
import { ActionCreator } from 'redux';

export const migrationStartedAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  const firebasePayload: FirebaseTypes.IEventActionPayload = {
    eventName: 'Migration_process_start',
  };
  return FirebaseActions.analyticsEventAction(firebasePayload);
};

export const migrationFinishedAction: ActionCreator<FirebaseActionTypes.IAnalyticsEventAction> = () => {
  const firebasePayload: FirebaseTypes.IEventActionPayload = {
    eventName: 'Migration_process_finish',
  };
  return FirebaseActions.analyticsEventAction(firebasePayload);
};
